/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9Inputs */

const en__field_bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9 = /** @type {(inputs: _Field_Bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`please share your special diet requirements`)
};

const de__field_bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9 = /** @type {(inputs: _Field_Bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte teilen Sie uns Ihre Besondere Ernährungsgewohnheiten und Allergien mit`)
};

/**
* | output |
* | --- |
* | "please share your special diet requirements" |
*
* @param {_Field_Bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9 = /** @type {((inputs?: _Field_Bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9(inputs)
	return de__field_bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9(inputs)
});
export { _field_bitteteilensieunsihrebesonderenernhrungsgewohnheitenundallergienmit9 as "_field_bitteTeilenSieUnsIhreBesonderenErnhrungsgewohnheitenUndAllergienMit" }